module.exports = __webpack_public_path__ + "img/mastercard-small.fa287491.svg";